import { render, staticRenderFns } from "./OrticForm.vue?vue&type=template&id=2179aa94&"
import script from "./OrticForm.vue?vue&type=script&lang=js&"
export * from "./OrticForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports